module.exports = __webpack_public_path__ + "img/刑法.7d43def9.png";